export default __webpack_public_path__ + "static/media/map.2441f465.png";